import { NgModule } from '@angular/core';

import { PictrueUploaderComponent } from './pictrue-uploader.component';
import {NgUploaderModule} from 'ngx-uploader';
import { CommonModule } from '@angular/common';

@NgModule({
    imports:      [ CommonModule, NgUploaderModule ],
    exports: [ PictrueUploaderComponent],
    declarations: [ PictrueUploaderComponent ],
})
export class PictrueUploaderModule {  }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/pictrue-uploader/pictrue-uploader.module.ts